/* ControlUserSession.js */

"use strict";
const _ = require("lodash");
const UserSession = require("./UserSession");

class ControlUserSession extends UserSession {
    constructor(logger, router, di, userFeedback, UserEntity) {
        super(logger, UserEntity);
        this._router = router;
        this._di = di;
    }
    /*******************************************/
    /* START HANDLER METHODS */
    /*******************************************/
    _onConnectionLost() {
        this.emit("ConnectionLost");
    }

    _onConnectionShutdown() {
        this.emit("ConnectionShutdown");
    }

    _onNotAuthenticated() {
        this.emit("NotAuthenticated");
    }

    _onUnAuthenticated(cause) {
        this.emit("UnAuthenticated", cause);
        this._unregisterConnectionListeners();
    }
    _onReconnectionAttempt(data) {
        this.emit("ReconnectionAttempt", data);
    }
    _onReconnectionEstablished() {
        this.emit("ReconnectionEstablished");
    }
    _onReconnectionFailed() {
        this.emit("ReconnectionFailed");
    }
    /*******************************************/
    /* END HANDLER API METHODS */
    /* START PRIVATE API METHODS */
    /*******************************************/

    _connectAndAuthenticate(creds, systemUri, port = 443, path = "/ControlApi/socket.io") {
        this._connection = this._ConnectionHandlerFactory.getInstance("socket", systemUri, port, {
            path: path,
            reconnectionDelay: 6000,
        });

        return this._connection
            .connect()
            .then(() => {
                return this._connection.authenticate(
                    creds.username,
                    creds.password,
                    creds.challengeState
                );
            })
            .then((response) => {
                if (response && response.challenge) {
                    return response;
                } else {
                    this._registerConnectionListeners();
                    this._token = response.token;
                    return this._UserEntityDefinition.retrieveByOtk(this._token).then((user) => {
                        this._userEntity = user;
                        // Set Active Org from user entity tenant id if not present
                        if (!(this.activeOrganization && this.activeOrganization.id)) {
                            const orgToBeSelected = {
                                name: this._userEntity.authorizedTenants[this._userEntity.tenantId]
                                    .name,
                                id: this._userEntity.tenantId,
                            };
                            this.setActiveOrganization(orgToBeSelected, true);
                        }
                        this.emit("Authenticated", this._userEntity);
                    });
                }
            });
    }
    /*******************************************/
    /* END PRIVATE API METHODS */
    /* START PUBLIC API METHODS */
    /*******************************************/
    login(creds) {
        //jshint ignore:line
        let preAuthPromise = Promise.resolve();
        if (this.isConnectedAndAuthenticated()) {
            let prevLoggedInUser = _.get(this._userEntity, "userName");
            let newLoggedInUser = _.get(creds, "username");
            if (prevLoggedInUser && newLoggedInUser && newLoggedInUser === prevLoggedInUser) {
                return Promise.resolve(this._userEntity);
            }
            preAuthPromise = this._connection.unauthenticate();
        }
        let systemUri = this._router.protocol + "//" + this._router.hostname;
        let port = this._router.port;
        let path = "/ControlApi/socket.io";
        return preAuthPromise.then(() => {
            return this._connectAndAuthenticate(creds, systemUri, port, path);
        });
    }

    shutdown() {
        this._unregisterListeners();
        this._router = undefined;
    }

    getAuthorizedActions() {
        if (this._userEntity) {
            return this._userEntity.authorizedActions;
        }
    }

    get authorizedActions() {
        return this.getAuthorizedActions();
    }
    /*******************************************/
    /* END PUBLIC API METHODS */
    /*******************************************/
}

module.exports = ControlUserSession;
